import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-group"
}
const _hoisted_2 = { class: "items" }
const _hoisted_3 = { class: "pagination" }
const _hoisted_4 = {
  key: 0,
  class: "pagination"
}
const _hoisted_5 = {
  key: 1,
  class: "pagination"
}
const _hoisted_6 = {
  key: 2,
  class: "pagination"
}

import PaginationBack from '../atoms/PaginationBack.vue'
import PaginationElement from '@/design-system/atoms/PaginationElement.vue'
import PaginationEllipsis from '@/design-system/atoms/PaginationEllipsis.vue'
import PaginationNext from '../atoms/PaginationNext.vue'
import { Attachment, AttachmentsPage } from '@/services/attachments.service'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

// emits

export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationGroupCustom',
  props: {
    attachmentsPage: {}
  },
  emits: ["next", "back", "page"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

// props
const props = __props
// data
const { t } = useI18n()
const activePage = ref<number>(1)
const lastPage = computed<boolean>(() => props.attachmentsPage?.totalPages === activePage.value)

const lastPages = computed<number[]>(() => {
  if (!props.attachmentsPage?.totalPages) return [0]
  return [
    props.attachmentsPage?.totalPages - 4,
    props.attachmentsPage?.totalPages - 3,
    props.attachmentsPage?.totalPages - 2,
    props.attachmentsPage?.totalPages - 1,
    props.attachmentsPage?.totalPages
  ]
})

// methods
function handleClickBack() {
  if (activePage.value > 1) {
    activePage.value--
    emits('back')
  }
}
function handleClickNext() {
  if (!lastPage.value) {
    activePage.value++
    emits('next')
  }
}
function setActivePage(value: number) {
  activePage.value = value
  emits('page', value - 1) // -1 because the attachementsPage is 0 based
}
watch(
  () => props.attachmentsPage,
  (newVal) => {
    if (!newVal) return
    activePage.value = newVal.number + 1
  }
)

return (_ctx: any,_cache: any) => {
  return (_ctx.attachmentsPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('general__text__showing') +
        ' ' +
        _ctx.attachmentsPage.numberOfElements +
        ' ' +
        _unref(t)('general__text__of').toLocaleLowerCase() +
        ' ' +
        _ctx.attachmentsPage.totalElements +
        ' ' +
        _unref(t)('general__label__files').toLocaleLowerCase()), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PaginationBack, {
            disabled: activePage.value === 1,
            onOnClicked: handleClickBack
          }, null, 8, ["disabled"]),
          (_ctx.attachmentsPage.totalPages <= 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentsPage?.totalPages, (pageNumber) => {
                  return (_openBlock(), _createBlock(PaginationElement, {
                    key: pageNumber,
                    page: pageNumber,
                    isActive: activePage.value,
                    onOnClicked: setActivePage
                  }, null, 8, ["page", "isActive"]))
                }), 128))
              ]))
            : (lastPages.value.includes(activePage.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
            _ctx.attachmentsPage.totalPages - 4,
            _ctx.attachmentsPage.totalPages - 3,
            _ctx.attachmentsPage.totalPages - 2,
            _ctx.attachmentsPage.totalPages - 1,
            _ctx.attachmentsPage.totalPages
          ], (pageNumber) => {
                    return (_openBlock(), _createBlock(PaginationElement, {
                      key: pageNumber,
                      page: pageNumber,
                      isActive: activePage.value,
                      onOnClicked: setActivePage
                    }, null, 8, ["page", "isActive"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([activePage.value, activePage.value + 1], (pageNumber) => {
                    return (_openBlock(), _createBlock(PaginationElement, {
                      key: pageNumber,
                      page: pageNumber,
                      isActive: activePage.value,
                      onOnClicked: setActivePage
                    }, null, 8, ["page", "isActive"]))
                  }), 128)),
                  _createVNode(PaginationEllipsis),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.attachmentsPage.totalPages - 1, _ctx.attachmentsPage.totalPages], (pageNumber) => {
                    return (_openBlock(), _createBlock(PaginationElement, {
                      key: pageNumber,
                      page: pageNumber,
                      isActive: activePage.value,
                      onOnClicked: setActivePage
                    }, null, 8, ["page", "isActive"]))
                  }), 128))
                ])),
          _createVNode(PaginationNext, {
            disabled: lastPage.value,
            onOnClicked: handleClickNext
          }, null, 8, ["disabled"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})